/* ViskoLove visitor tracking → the code service's dashboard (slot.uralmedical.com/stats).
   One first-party visitor id per browser (localStorage vl_vid). Every page view and the
   key clicks go to POST {api}/t as a text/plain beacon (no CORS preflight, survives the
   page leaving). The moment a person types their e-mail into the slot (or the footer
   newsletter), vlTrack.identify() links the id to that e-mail + phone, so what they looked
   at before and after is on their record. Location comes from Cloudflare on the server;
   no IP is stored. Configured by window.vlTrackCfg (layout/theme.liquid). */
(function () {
  var cfg = window.vlTrackCfg || {};
  if (!cfg.api) return;
  var api = String(cfg.api).replace(/\/$/, '');
  var KEY = 'vl_vid';
  var vid = '';
  try {
    vid = localStorage.getItem(KEY) || '';
    if (!vid) {
      vid = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : (Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10));
      localStorage.setItem(KEY, vid);
    }
  } catch (e) { vid = 'anon-' + Math.random().toString(36).slice(2, 10); }
  var ident = {};
  try { ident = JSON.parse(localStorage.getItem('vl_ident') || '{}') || {}; } catch (e) { ident = {}; }
  /* a slot record from before this script existed still names the person */
  if (!ident.email) {
    try { var slot = JSON.parse(localStorage.getItem('vlSlotWin') || 'null'); if (slot && slot.email) ident = { email: slot.email, phone: slot.phone || '' }; } catch (e) {}
  }
  if (!ident.email && cfg.customer) ident = { email: cfg.customer, phone: '' };
  /* a session = a visit: it starts after 30 minutes of silence, or the moment the person arrives
     through a (different) campaign link. Only its first beacon carries the referrer and the landing
     query (utm_…, gclid, fbclid) — that is what the panel's channel / campaign tables are built from. */
  var firstOfSession = false, sid = '';
  try {
    var now = Date.now(), tagged = /[?&](utm_source|utm_campaign|gclid|gbraid|wbraid|gad_source|gmcpmax|fbclid|ttclid|msclkid|srsltid)(=|&|$)/.test(location.search);
    var se = JSON.parse(localStorage.getItem('vl_sess') || 'null');
    if (!se || !se.id || now - se.last > 30 * 60000 || (tagged && se.q !== location.search)) {
      se = { id: now.toString(36) + Math.random().toString(36).slice(2, 8), q: tagged ? location.search : '' };
      firstOfSession = true;
    }
    se.last = now; sid = se.id;
    localStorage.setItem('vl_sess', JSON.stringify(se));
  } catch (e) {
    try { if (!sessionStorage.getItem('vl_s')) { sessionStorage.setItem('vl_s', '1'); firstOfSession = true; } }
    catch (e2) {
      /* no storage at all (strict private mode, some in-app browsers): every page stands alone, so an arrival is
         recognised by where it came from — a campaign link, or a referrer that is not this shop. The server gives
         such a browser one id per day, so it is still one visitor with one first touch. */
      var rh = ''; try { rh = document.referrer ? new URL(document.referrer).hostname : ''; } catch (e3) {}
      firstOfSession = /[?&](utm_source|utm_campaign|gclid|gbraid|wbraid|gad_source|gmcpmax|fbclid|ttclid|msclkid|srsltid)(=|&|$)/.test(location.search) || rh !== location.hostname;
    }
  }

  var send = function (type, extra) {
    var body = {
      v: 2, vid: vid, sid: sid, type: type, t: Date.now(),
      path: location.pathname.slice(0, 200), page: cfg.page || '', handle: cfg.handle || '', title: (cfg.title || '').slice(0, 120),
      collection: cfg.collection || '', email: ident.email || '', phone: ident.phone || '',
      ss: (firstOfSession && type === 'pv') ? 1 : 0, ref: firstOfSession ? (document.referrer || '').slice(0, 300) : '', q: firstOfSession ? location.search.slice(0, 900) : '',
      sw: window.screen ? screen.width : 0
    };
    if (extra) for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) body[k] = extra[k];
    try { if (sid) { var cur = JSON.parse(localStorage.getItem('vl_sess') || 'null'); if (cur && cur.id === sid) { cur.last = Date.now(); localStorage.setItem('vl_sess', JSON.stringify(cur)); } } } catch (e) {}
    var json = JSON.stringify(body);
    try { if (navigator.sendBeacon && navigator.sendBeacon(api + '/t', new Blob([json], { type: 'text/plain' }))) return; } catch (e) {}
    try { fetch(api + '/t', { method: 'POST', keepalive: true, headers: { 'Content-Type': 'text/plain' }, body: json }).catch(function () {}); } catch (e) {}
  };

  window.vlTrack = {
    vid: vid,
    /* the retargeting card (assets/vl-offer.js) asks the service only at the start of a visit */
    sid: sid, newSession: firstOfSession,
    email: function () { return ident.email || ''; },
    send: send,
    identify: function (email, phone) {
      email = String(email || '').trim().toLowerCase();
      if (!email) return;
      ident = { email: email, phone: phone || ident.phone || '' };
      try { localStorage.setItem('vl_ident', JSON.stringify(ident)); } catch (e) {}
      send('identify');
    }
  };

  send('pv');

  /* the clicks that mean something for the shop */
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('a,button') : null;
    if (!el) return;
    var t = null, meta = {};
    var is = function (sel) { try { return el.matches(sel); } catch (err) { return false; } };
    if (is('[data-vl-buynow], [data-buynow]')) t = 'buynow';
    else if (is('[data-vl-havale]')) t = 'havale';
    else if (is('.vl-mp__atc, [data-vlx-add], [name="add"]')) t = 'atc';
    else if (is('[data-vl-set-add]')) { t = 'atc'; meta.set = (el.getAttribute('data-url') || '').slice(0, 80); }
    else if (is('[name="checkout"], a[href="/checkout"]')) t = 'checkout';
    else if (is('a[href*="wa.me"], a[href*="whatsapp"]')) t = 'whatsapp';
    else if (is('a[href*="/products/"]')) {
      t = 'product_click';
      var m = (el.getAttribute('href') || '').match(/\/products\/([a-z0-9-]+)/i);
      if (m) meta.to = m[1];
    }
    else if (is('.vl-mp__pill')) { t = 'variant'; meta.value = (el.getAttribute('data-value') || el.textContent || '').trim().slice(0, 40); }
    if (t) send(t, meta);
  }, true);

  /* the footer newsletter form names the person too */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.querySelector) return;
    var em = f.querySelector('input[type="email"], input[name="contact[email]"]');
    if (em && em.value && /@/.test(em.value)) window.vlTrack.identify(em.value, '');
  }, true);

  /* seconds spent on the page, sent once when it goes away */
  var t0 = Date.now(), gone = false;
  var leave = function () { if (gone) return; gone = true; send('leave', { sec: Math.min(3600, Math.round((Date.now() - t0) / 1000)) }); };
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') leave(); });
  window.addEventListener('pagehide', leave);
})();
